import React from 'react';
export const DataJson = React.createContext({
    Data: {},
    setData: () => null
})